import { Construction } from "lucide-react";

export default function ComingSoon({ title, description }) {
  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center p-8" data-testid="coming-soon-page">
      <div className="max-w-md w-full bg-white border border-black/5 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-10 text-center">
        <div className="w-14 h-14 rounded-xl bg-[#F50E02]/10 flex items-center justify-center mx-auto mb-5">
          <Construction className="h-6 w-6 text-[#F50E02]" />
        </div>
        <h2
          className="font-display text-2xl font-semibold tracking-tight text-[#0A0A0A]"
          data-testid="coming-soon-title"
        >
          {title}
        </h2>
        <p className="text-sm text-[#525252] mt-2" data-testid="coming-soon-subtitle">
          {description || "This module is coming soon. We're working on it."}
        </p>
        <div className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#F50E02] bg-[#F50E02]/10 px-3 py-1.5 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-[#F50E02] animate-pulse" />
          Coming Soon
        </div>
      </div>
    </div>
  );
}
